import { msg } from '@lingui/macro'
import { CrashPackageZipError } from './crash-package-zip-error'

/**
 * Messaggio utente per errori di export/download ZIP offline.
 *
 * @param {unknown} error
 * @returns {import('@lingui/core').MessageDescriptor}
 */
export function getCrashPackageZipUserMessage(error) {
  if (error instanceof CrashPackageZipError) {
    if (error.code === 'ORG_MISSING') {
      return msg`Each crash must have an organization to export a server-compatible ZIP.`
    }
    if (error.code === 'ORG_MIXED') {
      return msg`All crashes in the export must belong to the same organization.`
    }
    if (error.code === 'USER_MISSING') {
      return msg`Cannot export: user id is missing.`
    }
    if (error.code === 'EMPTY') {
      return msg`No offline crashes to export. Save reports with “Save and Download” first (drafts on device only are not included).`
    }
  }
  return msg`Crash saved offline, but the ZIP download failed. Use Export from the Offline toolbar.`
}
